import { AGENT_TRACKER_ROLE } from "vue-app/types/enums";

export {
  AI_AGENT_WIDGET_TYPE,
  AI_AGENT_INBOX_SOURCE,
  AI_AGENT_SOURCE_TYPE,
  AI_AGENT_MESSAGE_TYPE,
  positionOptions,
  sizeOptions,
  deviceOptions,
  sizePixelMap,
  languageOptions,
} from "./AIAgent.constants";

export type {
  AIAgentPosition,
  AIAgentSize,
  AIAgentDevice,
  AIAgentWidgetDTO,
  AIAgentLanguage,
} from "./AIAgent.types";

export { getMessages, aiAgentMessages } from "./AIAgent.messages";
export type { AIAgentMessages } from "./AIAgent.messages";

export const aiAgentRoute = {
  path: "/app/onsite/ai-agent-widget",
  name: "PageOnsiteAIAgent",
  component: () => import("./page/PageOnsiteAIAgent.vue"),
  meta: {
    routeName: window.$_t?.("ONSITE") ?? "ONSITE",
    requiredRoles: [AGENT_TRACKER_ROLE.ROLE_ONSITE],
    noPadding: true,
    skipGlobalLoader: true,
  },
};

export const aiAgentInboxConfig = {
  sourceType: "AI_AGENT" as const,
  color: "violet" as const,
  icon: "fa-light fa-sparkles",
  filterLabel: window._trans?._inbox?.inboxConversations?.filters?.source?.options?.aiAgent ?? "AI Agent",
};

export { default as AIAgentMessageBadge } from "./inbox/AIAgentMessageBadge.vue";
export { default as AIAgentProductCard } from "./inbox/AIAgentProductCard.vue";
export {
  getAIAgentColorMap,
  getAIAgentIconMap,
  isAIAgentMessage,
  isAIAgentResponseMessage,
  parseProductsFromContent,
} from "./inbox/AIAgentInbox.helpers";
export type { AIAgentProduct } from "./AIAgent.types";
